import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { StepperService } from '../../core/services/stepper.service';

export interface PartnerInscriptionStep {
  icon: string;
  label: string;
}

@Component({
  selector: 'umkt-partner-inscription-stepper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './partner-inscription-stepper.component.html',
  styleUrls: ['./partner-inscription-stepper.component.scss']
})
export class PartnerInscriptionStepperComponent implements OnInit, OnChanges, OnDestroy {
  @Input() steps: PartnerInscriptionStep[] = [];
  @Input() currentStepIndex: number = 0;
  @Input() standalone: boolean = false;
  @Input() labelTotalSteps?: number;
  @Input() labelCurrentStep?: number;
  @Input() labelPrefix: string = '';
  @Input() showCurrentStepLabel: boolean = true;
  @Input() useStatusIcons: boolean = false;

  public currentStepLabel: string = '';
  public totalSteps: number = 0;
  public currentStepNumber: number = 1;
  private stepSubscription?: Subscription;
  private effectiveStepIndex = 0;
  private stepperService = inject(StepperService);


  ngOnInit(): void {
    this.effectiveStepIndex = this.currentStepIndex;
    if (!this.standalone) {
      this.stepSubscription = this.stepperService.currentStep$.subscribe(index => {
        this.effectiveStepIndex = index;
        this.updateStepInfo();
      });
    } else {
      this.updateStepInfo();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.standalone && changes['steps']) {
      this.stepperService.setSteps(this.steps.length, false);
    }
    if (!this.standalone && changes['currentStepIndex'] && !changes['currentStepIndex'].firstChange) {
      this.effectiveStepIndex = this.currentStepIndex;
    }
    this.updateStepInfo();
  }

  private updateStepInfo(): void {
    const idx = this.standalone ? this.currentStepIndex : this.effectiveStepIndex;

    this.totalSteps = this.labelTotalSteps ?? this.steps.length;
    this.currentStepNumber = this.labelCurrentStep ?? (idx + 1);

    if (this.steps.length > 0 && idx >= 0 && idx < this.steps.length) {
      this.currentStepLabel = this.steps[idx].label;
    } else {
      this.currentStepLabel = '';
    }
  }

  getIconClasses(index: number): object {
    const stepIcon = this.steps[index]?.icon || 'mdn-Icon-engrenagem';
    const idx = this.standalone ? this.currentStepIndex : this.effectiveStepIndex;

    return {
      [stepIcon]: true,
      'mdn-Icon--md': true,
      'step-icon': true,
      'completed': index < idx,
      'active': index === idx,
      'pending': index > idx
    };
  }

  lineIsActive(segmentIndex: number): boolean {
    const idx = this.standalone ? this.currentStepIndex : this.effectiveStepIndex;
    return idx > segmentIndex;
  }

  getStepState(index: number): 'completed' | 'active' | 'pending' {
    const idx = this.standalone ? this.currentStepIndex : this.effectiveStepIndex;
    if (index < idx) return 'completed';
    if (index === idx) return 'active';
    return 'pending';
  }

  ngOnDestroy(): void {
    this.stepSubscription?.unsubscribe();
  }
}
